import * as GC from "../../components/common/common";
import {JwtProvider, msalAuth} from "../msal/MsalAuthProvider";

export async function handleResponse(response) {
  if (response.status === 401) {
    // So, a server-side validation error occurred.
    // Server side validation returns a string error message, so parse as text instead of json.
    //const error = await response.text();
    if (localStorage.getItem("accessToken") !== "logged-out"){
      const token = await GC.GetToken()
      await localStorage.setItem("accessToken", token);

      throw new Error("401");
    } else {
      await JwtProvider();
      msalAuth.loginRedirect({});
      return
    }
    // const token = await GC.GetToken()
    // await localStorage.setItem("accessToken", token);
  }

  if (response.ok) {
    return response.json();
  }
  if (response.status === 400) {
    // So, a server-side validation error occurred.
    // Server side validation returns a string error message, so parse as text instead of json.
    const error = await response.text();
    throw new Error(error);
  }

  throw new Error("Network response was not ok.");
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error("API call failed. " + error);
  throw error;
}


export async function handleResponseBulkUpdate(response) {
  return new Promise(function (resolve, reject) {
    try {
      JSON.parse(response);
    } catch (e) {
      resolve({})
    }
    handleResponse(response).then((res) => {
      if (res && res.result.hasOwnProperty('errors') && res.result.errors.length > 0){
        reject(res.result.errors[0].detail);
      }
      else resolve(res);
    }).catch(reject);
  });
}
